import { Department } from '@app/models';

export interface Follow {
  id: number;
  AuthorId: number;
  DepartmentId: number;
  SeasonId: number;
  year: number;
  createdAt: Date;
  Factors: any[];
  typeMoneyClp: boolean;
  ExchangeRates: any[];
  productsCount: number;
  Taxes: any[];
  plannerId: string;
  type: string;
  Businesses?: any[];
  ParentId: number;
  description: string;
  FollowGroupId: number;
  status: number;
  statusName: string;
  dates: any;
  SarStates?: any[];
  pendingSarCounter?: any;
  Retroplannings?: any[];
  FollowArrivals?: any[];
  canceled: boolean;
  arrivals: boolean;
  ArrivalState: any;
  purchaseAvailable?: boolean;
}

export const FollowTypes = {
  Clothing: 'VESTUARIO',
  Paris: 'PARIS',
  ParisClothing: 'PARIS VESTUARIO',
  Home: 'HOGAR',
  Electro: 'ELECTRO',
  Pets: 'MASCOTAS',
  AltElectro: 'ALTELECTRO',
  Food: 'FOOD'
};

export const FollowLoadStatus = {
  READY: 'READY',
  LOADING: 'LOADING'
};

export function createMockFollow(): Follow {
  return {
    id: 2,
    AuthorId: 1,
    SeasonId: 1,
    DepartmentId: 1,
    year: 2018,
    productsCount: 0,
    createdAt: new Date(),
    Factors: [],
    typeMoneyClp: false,
    ExchangeRates: [],
    Taxes: [],
    plannerId: 'BEBÉS',
    type: 'VESTUARIO',
    description: 'Gerencia A',
    ParentId: 1,
    FollowGroupId: 1,
    status: 0,
    statusName: 'Creado',
    dates: {},
    canceled: false,
    arrivals: false,
    ArrivalState: false,
    purchaseAvailable: false
  };
}

export const getFollowDepartmentName = (
  follow,
  entities: { [id: number]: Department }
) => {
  const department = entities[follow.DepartmentId];
  let parent;
  if (department && department.level === 2) {
    parent = entities[department.ParentId];
  }
  if (parent && department) {
    if (parent.name === department.name) {
      return department.name;
    } else {
      return `${parent.name} - ${department.name}`;
    }
  } else if (department && department.level === 1) {
    return department.name;
  }
};
